import { render, staticRenderFns } from "./P03ThreeDigit.vue?vue&type=template&id=3ca1bdaa&scoped=true"
import script from "./P03ThreeDigit.vue?vue&type=script&lang=js"
export * from "./P03ThreeDigit.vue?vue&type=script&lang=js"
import style0 from "./P03ThreeDigit.vue?vue&type=style&index=0&id=3ca1bdaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1bdaa",
  null
  
)

export default component.exports